export default "__VITE_ASSET__BPxEGywS__"